// extracted by mini-css-extract-plugin
module.exports = {"title":"GiftPhotos_title__2jpr3","gift-photo":"GiftPhotos_gift-photo__1Y8sl"};